import React, { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { Input } from '@factorialco/f0-react/dist/experimental'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateComplaintsCategory } from 'modules/complaints/hooks/useCreateComplaintsCategory'

interface AddCategoryModalProps {
  open: boolean
  onClose: () => void
}

export const AddCategoryModal = ({ open, onClose }: AddCategoryModalProps) => {
  const [categoryName, setCategoryName] = useState('')
  const { createComplaintsCategory, loading } = useCreateComplaintsCategory()

  const handleSubmit = async () => {
    if (!categoryName.trim()) return

    const result = await createComplaintsCategory({
      name: categoryName.trim(),
    })
    const handledResult = handleResult(result, () => {})

    if (handledResult.success) {
      setCategoryName('')
      onClose()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'app_store_v2.apps.complaints.settings.categories.save_category_error_message'
        ),
      })
    }
  }

  return (
    <F0Dialog
      isOpen={open}
      onClose={onClose}
      title={i18n.t('app_store_v2.apps.complaints.settings.categories.new_category')}
      primaryAction={{
        label: loading ? i18n.t('common.saving') : i18n.t('common.save'),
        onClick: handleSubmit,
        disabled: !categoryName.trim() || loading,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('gender_settings.edit.cancel'),
        onClick: onClose,
      }}
    >
      <Box gap="s12">
        <Input
          label={i18n.t('app_store_v2.apps.complaints.settings.categories.category_name')}
          value={categoryName}
          onChange={(value: string) => setCategoryName(value)}
          placeholder={i18n.t(
            'app_store_v2.apps.complaints.settings.categories.category_name_placeholder'
          )}
        />
      </Box>
    </F0Dialog>
  )
}
